/**
 * Types for AI bill scanning feature
 */

import type { BillFrequency, CreateBillInput } from './bill.types';

export interface ScanBillsInput {
  accountIds?: string[];
  dateFrom: string;
  dateTo: string;
}

export interface DetectedBillCandidate {
  /** Client-side temp id for checkbox keys */
  id: string;
  name: string;
  amount: number;
  frequency: BillFrequency;
  /** YYYY-MM-DD (next due occurrence) */
  dueDate: string;
  dayOfMonth?: number;
  categoryId?: string;
  categoryName?: string;
  confidence?: number;
  occurrenceCount?: number;
  /** Set client-side after dedup against existing bills */
  alreadyExists?: boolean;
}

export interface CreateBillsFromScanResult {
  created: number;
  failed: Array<{ name: string; message: string }>;
}

export type ScanBillsServiceError =
  | { code: 'PROVIDER_UNAVAILABLE'; message: string; retryAfter?: number }
  | { code: 'MONTHLY_LIMIT_REACHED'; message: string }
  | { code: 'VALIDATION_ERROR'; message: string }
  | { code: 'AI_ERROR'; message: string }
  | { code: 'UNKNOWN_ERROR'; message: string };

export interface ScanBillsResponse {
  data?: DetectedBillCandidate[];
  error?: ScanBillsServiceError;
}

export interface CreateBillsFromScanResponse {
  data?: CreateBillsFromScanResult;
  error?: ScanBillsServiceError;
}

export function candidateToCreateInput(c: DetectedBillCandidate): CreateBillInput {
  return {
    name: c.name,
    displayName: c.name,
    source: 'scan',
    amount: c.amount,
    frequency: c.frequency,
    dueDate: c.dueDate,
    ...(c.categoryId ? { categoryId: c.categoryId } : {}),
    ...(c.dayOfMonth != null ? { dayOfMonth: c.dayOfMonth } : {}),
    autopay: false,
  };
}
